const actions = {
  SET_STATE: 'extensions/SET_STATE',
  EXTENSIONS_LIST: 'extensions/EXTENSIONS_LIST',
  ENTER_EXTENSION_TEXT: 'extensions/ENTER_EXTENSION_TEXT',
  CHANGE_EXTENSION_STATUS: 'extensions/CHANGE_EXTENSION_STATUS',
  ENABLE_DISABLE_EXTENSION: 'extensions/ENABLE_DISABLE_EXTENSION',
}

export default actions
